import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root'
})
export class MatIconRegistryService {

	icons = [
		{ name: 'circlen1', url: '/assets/icons/circlen1.svg' },
		{ name: 'circlen2', url: '/assets/icons/circlen2.svg' },
    { name: 'circlen3', url: '/assets/icons/circlen3.svg' },
    { name: 'circlen4', url: '/assets/icons/circlen4.svg' },
    { name: 'circlen5', url: '/assets/icons/circlen5.svg' },
    { name: 'circlen6', url: '/assets/icons/circlen6.svg' },
    { name: 'squares_four', url: '../../../assets/icons/squares-four.svg' },
    { name: 'users', url: '../../../assets/icons/users.svg' },
    { name: 'calendar', url: '../../../assets/icons/calendar.svg' },
    { name: 'invoice', url: '../../../assets/icons/invoice.svg' },
    { name: 'building', url: '../../../assets/icons/building.svg' },
    { name: 'desktop', url: '../../../assets/icons/desktop.svg' },
    { name: 'mail', url: '../../../assets/icons/mail.svg' },
    { name: 'gear', url: '../../../assets/icons/gear.svg' },
    { name: 'user_gear', url: '../../../assets/icons/user_gear.svg' },
    { name: 'bell', url: '../../../assets/icons/bell.svg' },
    { name: 'arrow_down', url: '../../../assets/icons/arrow_down.svg' },
    { name: 'arrow_up', url: '../../../assets/icons/arrow_up.svg' },

	];

	constructor(
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer
	) { }

	initializeAppIcons() {

		this.icons.map( icon => {
			this.matIconRegistry.addSvgIcon(
				`app_${icon.name}`,
				this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
			);
		});
	}

}
